import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import React, { useState } from 'react';
import { MyMBase64Image } from '../ui-elements/MyMBase64Image';
import { MyMImage } from '../ui-elements/MyMImage';
import { MyMLabel } from '../ui-elements/MyMLabel';
import { NavigateLink } from './NavigateLink';
import { useMediaQuery } from '../hooks/useMediaQuery';

/**
 * ItAppLinkCard Component
 */
export const ItAppLinkCard = ({ screenId, nameAbb, nameOfficial, link, logoEncodeBase64Data, logoFileExtension, controlSettings, baseColor, apiRequest, itAppId, isHomeView }) => {
  const [hovered, setHovered] = useState(false);
  const navigateItPage = (url, itAppId) => {
    apiRequest.requestJson('api/it-applications/external-link-transition?itAppId=' + itAppId, 'GET', null, null, null);
  }
  /* 2025.7.7 MyMine Version3.0対応 Add Start */
  const isMobile = useMediaQuery('max-width:1400px');
  /* 2025.7.7 MyMine Version3.0対応 Add End */

  const cardMobileSize = {
    height:
      isMobile ? '79px' : '73px',
    width:
      isMobile ? '220px' : '12vw'
  };

  return (
    <Card sx={{
      position: 'relative',
      display: 'block',
      textShadow: '1px 1px 1px rgba(0, 0, 0, 0.3)',
      height: isHomeView ? cardMobileSize.height : '100px',
      width: isHomeView ? cardMobileSize.width : '150px',
      borderRadius: '15px',
      backgroundColor: baseColor,
    }}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
      className= {isHomeView && "d-flex align-items-center justify-content-center"}
    >
      {link ?
        <Link href={link} color='inherit' target='_blank' underline='none' onClick={() => navigateItPage(link, itAppId)}>
          {
            (logoEncodeBase64Data !== null && hovered) &&
            <Box sx={{ height: '100%', width: '100%', backgroundColor: 'white' }} className={isHomeView && "d-flex justify-content-center"}>
              <MyMBase64Image
                encodeData={logoEncodeBase64Data}
                fileExtension={logoFileExtension.split('.').pop()}
                  alt='ItAppLogo'
                  width={isHomeView ? '50%' : '99%'}
                height='auto'
                display='block'
                sx={{ opacity: '0.5', zIndex: '10' }}
              />
            </Box>
          }
          {
            (logoEncodeBase64Data === null && hovered) &&
            <Box className={isHomeView && "d-flex align-items-center justify-content-center"}>
            <MyMImage
              screenId={screenId}
              filePath='NoImage.png'
              alt='ItAppLogo'
              width={isHomeView ? '53%' : '99%'}
              height='auto'
              display='block'
              sx={{ opacity: '0.5', zIndex: '10' }}
            />
            </Box>
          }
          <Box sx={{
            position: 'absolute',
            top: '0',
            left: '0',
            backgroundColor: 'rgb(13 13 13 / 55%)',
            color: 'white',
            padding: '10px',
            height: '100%',
            width: '100%',
            zIndex: '20'
          }}>
            <MyMLabel fontSize='max(0.7vw, 15px)' sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              WebkitTransform: 'translate(-50%, -50%)',
              msTransform: 'translate(-50%, -50%)',
              textAlign: 'center',
              color: 'white',
              width: '100%'
            }}>
              {nameAbb ? `${nameAbb}\n(${nameOfficial})` : nameOfficial}
            </MyMLabel>
          </Box>
        </Link>
        : <NavigateLink to='/MyM102/MyM305' underline='none' color='inherit' sx={{ width: '100%', height: '100%' }}>
          <Box sx={{
            position: 'absolute',
            top: '0',
            left: '0',
            backgroundColor: 'rgb(13 13 13 / 55%)',
            color: 'white',
            padding: '10px',
            height: '100%',
            width: '100%',
            zIndex: '20'
          }}>
            <MyMLabel fontSize='max(1.0vw, 15px)' sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              WebkitTransform: 'translate(-50%, -50%)',
              msTransform: 'translate(-50%, -50%)',
              textAlign: 'center',
              color: '#47B1D1',
              width: '100%'
            }}>
              {controlSettings.LabelList.lnkAddNew}
            </MyMLabel>
          </Box>
        </NavigateLink>
      }
    </Card>);
};